import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { SaleModel } from 'app/models/sale.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SaleService extends BaseService<SaleModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'sale');
    }

    /** Toggle "Financeiro verificado" (tab Financeiro). */
    setFinancialVerified(saleId: number, financial_verified: boolean): Observable<{ financial_verified: boolean }> {
        return this.api.patchSub(`${this.endpoint}/${saleId}/financial-verified`, { financial_verified });
    }

    /**
     * Dados mínimos para PDF de etiqueta (NFs NORMAL/REMESSA aprovadas).
     * Não exige can_access_nfe — use em vez de /nfe/list no fluxo de etiqueta.
     */
    getLabelData(saleId: number): Observable<{
        sale_id: number;
        nfe_number: string | null;
        nfes: Array<{
            nfe_id: number;
            nfe_number: string;
            tipo: string;
            sale_delivery_address_id: number | null;
        }>;
    }> {
        return this.api.getSub(`${this.endpoint}/${saleId}/label-data`);
    }

    /**
     * Cancela uma venda (marca is_canceled como true e deleta production_order_sale)
     */
    cancel(saleId: number): Observable<SaleModel> {
        return this.api.postSub<SaleModel, {}>(`${this.endpoint}/${saleId}/cancel`, {});
    }

    /**
     * Duplica uma venda
     */
    duplicate(saleId: number): Observable<SaleModel> {
        return this.api.postSub<SaleModel, {}>(`${this.endpoint}/${saleId}/duplicate`, {});
    }

    /**
     * Revisa comissões em massa
     */
    reviewCommissions(data: { user_seller_id: number; sale_ids: number[]; new_commission_percentage: number }): Observable<any> {
        return this.api.postSub<any, { user_seller_id: number; sale_ids: number[]; new_commission_percentage: number }>(
            `${this.endpoint}/review-commissions`,
            data
        );
    }
}
